import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Snapshot} from "../../models/snpashot.model";
import {TranslatedPage} from "../../pages/translated.page";
import {CommonUtils} from "../../utils/common";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-change',
  templateUrl: './change.component.html',
  styleUrls: ['./change.component.scss'],
})
export class ChangeComponent implements OnInit {

  @Output() closeEmitter = new EventEmitter<string>();

  @Input() modelName: string;
  @Input() snapshots: Snapshot[];
  @Input() isHistoryAvailable: boolean;

  public constValues: Map<string, boolean> = new Map<string, boolean>([
    ['true', true],
    ['false', true]
  ]);

  public filteredProperties: Map<string, boolean> = new Map<string, boolean>([
    ['models.User.jwtAuthEnabled', true],
    ['models.User.jwtHash', true],
  ]);

  private initializeTranslation: boolean = true;
  private language: string;

  constructor(public commonUtils: CommonUtils, private translateServiceLib: TranslateService) {
  }

  ngOnInit() {
    this._initTranslate();
  }

  exit() {
    this.closeEmitter.emit('close');
  }

  getDate(date: { date: { year: number; month: number; day: number }; time: { hour: number; minute: number; second: number; nano: number } } | string) {
    if (typeof date === 'string') return new Date(date);
    return new Date(date.date.year, date.date.month - 1, date.date.day, date.time.hour, date.time.minute, date.time.second)
  }

  getProperties = (properties: Map<string, any>) => {
    let propsMap: Map<string, string> = new Map<string, string>();

    if (properties) {
      for (const [key, value] of Object.entries(properties)) {
        if (this.filteredProperties.has(key)) continue;

        if (typeof value === 'object' && value !== null) {
          const cName = value?.constructor?.name;
          let exValueStr = '';
          if (cName === 'Array') {
            let exValue = value.map(obj => Object.entries(obj));

            exValue.forEach(ev => {
              for (const [k, v] of ev) {
                if (k === 'typeName') {
                  // exValueStr += `<p><strong>${this.translateServiceLib.instant(`models.${v}.objName`)}</strong></p>`
                } else {
                  exValueStr += `<p>${k} -> ${v}</p>`
                }
              }
            })

            propsMap.set(key, exValueStr);
          } else {
            for (const [k, v] of Object.entries(value)) {
              if (k === 'typeName') {
                //  exValueStr += `<p><strong>${this.translateServiceLib.instant(`models.${v}.objName`)}</strong></p>`
              } else {
                exValueStr += `<p><strong>${k}</strong>: ${v}</p>`
              }
            }

            propsMap.set(key, exValueStr);
          }
        } else {
          propsMap.set(key, value);
        }
      }
    }

    return propsMap;
  }

  _translateLanguage(): void {
    this.translateServiceLib.use(this.language);
  }

  translationExist(key: string): boolean {
    return this.translateServiceLib.instant(key) !== key;
  }

  _initTranslate() {
    if (this.initializeTranslation && !TranslatedPage.translationInInitialized) {
      // Set the default language for translation strings, and the current language.
      this.translateServiceLib.setDefaultLang('pl');
      this.language = 'pl';

      if (this.translateServiceLib.getBrowserLang() !== undefined && this.language !== this.translateServiceLib.getBrowserLang()) {
        this.translateServiceLib.setDefaultLang('en');
        this.language = 'en';
      } else {
        this.language = 'pl';
      }

      this._translateLanguage();
    }
  }

  getChangeValue(changeValue: any) {
    if (changeValue != null) {
      const changeValueStr = changeValue.toString();
      if (this.constValues.has(changeValueStr)) {
        return this.translateServiceLib.instant(`changeComponent.staticValues.${changeValueStr}`);
      } else {
        if (changeValueStr.match(/2[0-9]{3}-[0-9]{2}-[0-9]{2}(.*)/)) {
          return this.commonUtils.dateTime2Str(this.commonUtils.dateFromString(changeValueStr));
        } else {
          return changeValueStr;
        }
      }
    } else {
      return changeValue;
    }
  }
}
